import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Chart from "react-apexcharts";
import MapeTable from './MapeTable';
import ForecastTable from './ForecastTable';
import SalesPersonSelection from './SalesPersonSelection';
import TopThreeModelMape from './TopThreeModelMape';
import { getCookie } from '../../services/DataRequestService';
import Banner from './Banner';
import Breadcrumb from '../common/Breadcrumb';
import Loader from '../common/Loader';





const { REACT_APP_API_BASE_URL } = process.env

const DetailsChart = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const { workflow } = location.state || {}; // Accessing wf from the state

  const [isLoading, setIsLoading] = useState(false)

  const [plotData, setPlotData] = useState([])
  const [options, setOptions] = useState({})

  const [graphResponse, setGraphResponse] = useState([])
  const [dataForGraph, setDataForGraph] = useState([])

  const [cityList, setCityList] = useState([]); // List of cities
  const [skuList, setSkuList] = useState([]); // List of SKUs for the selected city
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedSKU, setSelectedSKU] = useState("");
  const [showChart, setShowChart] = useState(false);



  const [mapeData, setMapeData] = useState([])
  const [topThreemapeData, setTopThreemapeData] = useState([])
  const [forecastTable, setForecastTable] = useState([])


  const [salesPersonList, setSalesPersonList] = useState([])

  const [getCityName, setGetCityName] = useState("")

  let dataArray = []
  let frequency_year = []



  useEffect(() => {
    getCharts()
    getTopOneMapeTable()
    // getTopThreeMapeTable()
    getForecastTable()
    // getSalesPerson()
  }, [])

  const handleGetCityName = (value) => {
    //console.log(value);
    getSalesPerson(value)
  }

  // Handle city selection
  const handleCityChange = (event) => {
    const city = event.target.value;
    setSelectedCity(city);

    // Filter SKUs based on selected city
    const cityData = graphResponse.find((item) => item.city === city);
    const skus = cityData ? cityData.data.map((skuItem) => skuItem.sku) : [];
    setSkuList(skus);

    // Reset SKU selection
    setSelectedSKU("");

    // Update dataForGraph with all data from the selected city
    const graphData = cityData ? cityData.data.flatMap((skuItem) => skuItem.data) : [];
    setDataForGraph(graphData);
  };

  const handleSKUChange = (event) => {
    const selectedSKU = event.target.value;
    setSelectedSKU(selectedSKU);

    // Filter data for the selected SKU in the selected city
    const cityData = graphResponse.find((item) => item.city === selectedCity);
    const skuData = cityData
      ? cityData.data.find((skuItem) => skuItem.sku === selectedSKU)?.data
      : [];
    setDataForGraph(skuData || []);


    dataArray = [
      {
        name: "Actual",
        data: skuData.map((item) => item.actual),
      },
      {
        name: "Predicted",
        data: skuData.map((item) => item.predicted),
      },
    ];

    frequency_year = dataForGraph.map((item) => item.frequency_year);



    const values = {
      chart: {
        id: `Dashboard_${getCookie("username")}`,
        type: "line",
        toolbar: {
          show: true,
        },
      },
      title: {
        text: 'Graph',
        align: 'center',
      },
      plotOptions: {

      },
      colors: [
        '#0A324A', // dark blue
        '#F79548', // Orange
        '##AC1424', // red
        '#23272B', // Dark Gray
        '#3A9AD9', // Light Blue
        '#8BC34A', // Light Green
        '#FF4081', // Pink
        '#673AB7', // Purple
        '#FFEB3B', // Yellow
        '#009688', // Teal
        // '#E91E63', // Magenta
        // '#4CAF50'  // Green
      ]
      ,
      dataLabels: {
        enabled: false,
        style: {
          fontSize: '6px',
          fontWeight: 900
        },
        formatter: function (val) {
          return val
        }
      },

      xaxis: {
        categories: frequency_year,
        // categories: [1, 2, 3, 4],  //time
        title: {
          text: 'Frequency Year',

        },
        labels: {
          style: {
            fontSize: "11px",

          },
          rotate: -45,

          formatter: function (val) {
            return val
          }
        },
      },
      yaxis: [
        {
          seriesName: 'Actual VS Predicted Value',
          // opposite: true,
          labels: {
            style: {
              fontSize: "14px",

            },
            formatter: function (val) {
              return val
            }
          },
          title: {
            text: "Actual VS Predicted Value",
            showAlways: true,
            floating: true,
            style: {
              color: "#426AB3"
            },

          },
        },
        ,
      ],
      grid: {
        show: false, // This will remove the grid lines
      },
    }
    setPlotData(dataArray)
    setOptions(values)
    setShowChart(true)

  };










  // // Filter data based on selected city and SKU
  // const getFilteredData = () => {
  //   const cityData = forecastData.find((item) => item.city === selectedCity);
  //   if (!cityData) return [];

  //   const skuData = cityData.data.find((skuItem) => skuItem.sku === selectedSKU);
  //   if (!skuData) return [];

  //   return skuData.data;
  // };

  const transformData = (data) => {
    return data.reduce((acc, item) => {
      acc[item.sku] = acc[item.sku] || { frequency_year: [], actual: [], predicted: [] };
      item.data.forEach((entry) => {
        acc[item.sku].frequency_year.push(entry.frequency_year);
        acc[item.sku].actual.push(entry.actual);
        acc[item.sku].predicted.push(entry.predicted);
      });
      return acc;
    }, {});
  };


  const getCharts = async (value) => {
    setIsLoading(true)
    const workflow_id = workflow.workflow_id
    try {
      // Construct the full URL by directly appending the query parameter
      // const url = `${REACT_APP_API_BASE_URL}/weekly_workflow_data?workflow_id=${workflow.workflow_id}`;
      const url = `${REACT_APP_API_BASE_URL}/getActPredFcastResults?workflow_id=${workflow_id}`;
      // const url = `http://localhost:8071/getActPredFcastResults?workflow_id=${"wf_bd7c3e51-2e06-42ac-80ae-82157c5f467121"}`;
      // 
      // Perform the GET request
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // access_token: UserService.getToken(), // Replace with your token retrieval function
        },
      });

      // Handle the response

      console.log("train:", response.data);
      setGraphResponse(response.data.data.cities)
      const cities = response.data.data.cities.map((item) => item.city);
      setCityList(cities);


      const groupedData = transformData(response.data.data.cities);

      // Extract SKU names
      if (value) setSelectedSKU(value)
      else {
        setSelectedSKU(Object.keys(groupedData)[0])
        value = Object.keys(groupedData)[0]
      }

      // let dataArray = [{ name: "Cam 1", data: [1, 2, 3, 4] }, { name: "Cam 2", data: [5, 6, 7, 8] },]
      let dataArray = [{ name: "f_value", data: groupedData[`${value}`].f_value }]

    } catch (error) {
      // Handle errors
      console.error("Error fetching workflows:", error.message);
      throw error;
    }
    setIsLoading(false)
  }



  const getTopOneMapeTable = async () => {
    const workflow_id = workflow.workflow_id

    try {
      // Construct the full URL by directly appending the query parameter
      // const url = `${REACT_APP_API_BASE_URL}/weekly_workflow_data?workflow_id=${workflow.workflow_id}`;
      const url = `${REACT_APP_API_BASE_URL}/getTopOneModelResults?workflow_id=${workflow_id}`;
      // const url = `http://localhost:8071/getTopOneModelResults?workflow_id=${"wf_bd7c3e51-2e06-42ac-80ae-82157c5f467121"}`;

      // Perform the GET request
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // access_token: UserService.getToken(), // Replace with your token retrieval function
        },
      });

      // Handle the response
      setMapeData(response.data.data.cities);


    } catch (error) {
      // Handle errors
      console.error("Error fetching workflows:", error.message);
      throw error;
    }
  }
  const getTopThreeMapeTable = async () => {
    const workflow_id = workflow.workflow_id
    try {
      // Construct the full URL by directly appending the query parameter
      // const url = `${REACT_APP_API_BASE_URL}/weekly_workflow_data?workflow_id=${workflow.workflow_id}`;
      const url = `${REACT_APP_API_BASE_URL}/getTopThreeModelResults?workflow_id=${workflow_id}`;
      // 
      // Perform the GET request
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // access_token: UserService.getToken(), // Replace with your token retrieval function
        },
      });

      // Handle the response
      setTopThreemapeData(response.data.data);


    } catch (error) {
      // Handle errors
      console.error("Error fetching workflows:", error.message);
      throw error;
    }
  }

  const getForecastTable = async () => {
    const workflow_id = workflow.workflow_id
    try {
      // Construct the full URL by directly appending the query parameter
      // const url = `${REACT_APP_API_BASE_URL}/weekly_workflow_data?workflow_id=${workflow.workflow_id}`;
      const url = `${REACT_APP_API_BASE_URL}/getForecastResults?workflow_id=${workflow_id}`;
      // const url = `http://localhost:8071/getForecastResults?workflow_id=${"wf_bd7c3e51-2e06-42ac-80ae-82157c5f467121"}`;
      // 
      // Perform the GET request
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // access_token: UserService.getToken(), // Replace with your token retrieval function
        },
      });

      // Handle the response
      // console.log(response.data.data);
      setForecastTable(response.data.data.cities);
    } catch (error) {
      // Handle errors
      console.error("Error fetching workflows:", error.message);
      throw error;
    }
  }

  const getSalesPerson = async (value) => {
    
    function capitalizeFirstLetter(str) {
      if (!str) return ""; // Return an empty string if input is empty or undefined
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
    try {
      // Construct the full URL by directly appending the query parameter
      // const url = `${REACT_APP_API_BASE_URL}/weekly_workflow_data?workflow_id=${workflow.workflow_id}`;
      const url = `${REACT_APP_API_BASE_URL}/get_sp?level5=${capitalizeFirstLetter(value)}`;
      // 
      // Perform the GET request
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // access_token: UserService.getToken(), // Replace with your token retrieval function
        },
      });

      // Handle the response      
      setSalesPersonList(response.data.data);


    } catch (error) {
      // Handle errors
      console.error("Error fetching workflows:", error.message);
      throw error;
    }
  }




  return (
    <>
      <Breadcrumb List={[{ path:"/Dashboard", name:"Dasboard"},{path:"/ManageWorkflow", name:"Workflow"} , { path:"#" , name:workflow.workflow_name }]} />
      <Banner />
      <br />
      <br />
      <br />
      {
        isLoading ?
          <center><Loader size={'large'} /></center>
          :
          <>
            <h2 style={{ margin: "2vh 0 8vh 0" }} className="text-3xl font-bold mb-4 text-center">Actual VS Predicted</h2>
            <div style={{ marginTop: "10vh 0 10vh 0" }} className="mycontainer manage-workflow-box">
              <div
                style={{ padding: "0 5vh" }}
                className="flex flex-wrap gap-5 container"
              >
                {/* <!-- City Dropdown --> */}
                <div className="my-4 flex flex-col md:flex-row items-center">
                  <label style={{ marginTop: "1.5vh" }} htmlFor="city-select" className="mr-2">
                    Select City :
                  </label>
                  <select
                    style={{ marginRight: "5vw" }}
                    id="city-select"
                    className="p-2 border rounded"
                    value={selectedCity}
                    onChange={handleCityChange}
                  >
                    <option value="">-- Select a City --</option>
                    {cityList.map((city, index) => (
                      <option key={index} value={city}>
                        {city}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <!-- SKU Dropdown --> */}
                <div className="my-4 flex flex-col md:flex-row items-center gap-2">
                  <label style={{ marginTop: "1.5vh" }} htmlFor="sku-select" className="mr-2">
                    Select SKU :
                  </label>
                  <select
                    id="sku-select"
                    className="p-2 border rounded"
                    value={selectedSKU}
                    onChange={handleSKUChange}
                    disabled={!selectedCity}
                  >
                    <option value="">-- Select an SKU --</option>
                    {skuList.map((sku, index) => (
                      <option key={index} value={sku}>
                        {sku}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <br />
              
              
              {
                showChart &&
                <Chart
                  align="center"
                  options={options}
                  series={plotData}
                  type="line"
                  height={500}
                  width={'80%'}
                />
              }
              <br />


            </div>


            {/* mape table */}
            <MapeTable mapeData={mapeData} />
            {/* mape table top three */}
            {/* <TopThreeModelMape topThreemapeData={topThreemapeData} /> */}
            {/* forcast table */}
            <ForecastTable forecastData={forecastTable} handleGetCityName={handleGetCityName} />
            {/* Sales Person */}
            <SalesPersonSelection salesPersonList={salesPersonList} workflow_id={workflow.workflow_id} approvStatus={workflow.approval_status} />
            <br />
            <br />
          </>}
    </>
  )
}

export default DetailsChart
